"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using double square brackets with dollar signs (`[[$` `$]]`).
 * Matches tags of the form `[[$variable$]]` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello [[$variable$]]';
 * const result = replaceTags(text, { variable: 'world' }, DoubleSquareBracketsWithDollarSigns);
 * console.log(result); // Output: 'Hello world'
 */
var DoubleSquareBracketsWithDollarSigns = {
    name: "Double Square Brackets With Dollar Signs",
    openingTag: "[[$",
    closingTag: "$]]",
    tagPattern: /\[\[\$(.*?)\$\]\]/g,
    tagStartPattern: /^\[\[\$/,
    tagEndPattern: /\$\]\]$/,
};
exports.default = DoubleSquareBracketsWithDollarSigns;
